import styled from 'styled-components'

export const Container = styled.svg<{ $color?: string }>`
  color: ${({ $color }) => $color ?? 'currentColor'};
  &[aria-hidden='true'] {
    pointer-events: none;
  }
`
